import { UserFragmentFragment } from "../gql/graphql.ts";
import { UserDetailModal } from "./UserDetailModal.tsx";
import { useSendResetPasswordEmail } from "./useSendResetPasswordEmail.ts";
import { useMessagePopupController } from "../UI/MessagePopup/useMessagePopupController.ts";
import { InfoMessagePopup } from "../UI/MessagePopup/InfoMessagePopup.tsx";
import { ErrorMessagePopup } from "../UI/MessagePopup/ErrorMessagePopup.tsx";
import { useToCreateClassRoomPlanScreen } from "./ClassRoomPlan/useToCreateClassRoomPlanScreen.ts";
import { useToUpdateClassRoomPlanScreen } from "./ClassRoomPlan/useToUpdateClassRoomPlanScreen.ts";

export function UserDetailModalWithActions({
  user,
  onClose,
}: {
  user: UserFragmentFragment;
  onClose: () => void;
}) {
  const { toCreateClassRoomPlan } = useToCreateClassRoomPlanScreen();
  const { toUpdatePlanScreen } = useToUpdateClassRoomPlanScreen();
  const { sendResetPasswordEmail, loading: sendingResetPasswordEmail } =
    useSendResetPasswordEmail();

  const infoPopup = useMessagePopupController(3000);
  const errorPopup = useMessagePopupController(3000);

  async function handleSendResetPasswordEmail(
    user: UserFragmentFragment,
  ): Promise<void> {
    try {
      await sendResetPasswordEmail(user.id);
      infoPopup.showPopup(
        "Email sent",
        `Reset password email sent to ${user.email}`,
      );
    } catch {
      errorPopup.showPopup(
        "Error",
        "Failed to send reset password email. Please try again.",
      );
    }
  }

  return (
    <>
      <UserDetailModal
        user={user}
        onClose={onClose}
        sendResetPasswordEmail={handleSendResetPasswordEmail}
        sendingResetPasswordEmail={sendingResetPasswordEmail}
        onNavigateToCreateClassRoomPlan={(userId) => {
          onClose();
          toCreateClassRoomPlan(userId);
        }}
        onNavigateToEditClassRoomPlan={(userId, planId) => {
          onClose();
          toUpdatePlanScreen({ userId, planId });
        }}
      />
      <InfoMessagePopup
        show={infoPopup.show}
        title={infoPopup.title}
        description={infoPopup.description}
      />
      <ErrorMessagePopup
        show={errorPopup.show}
        title={errorPopup.title}
        description={errorPopup.description}
      />
    </>
  );
}
